import { Provider, createStore } from "jotai";
import { queryClientAtom } from "jotai-tanstack-query";
import { queryClient } from "@humansignal/core/lib/utils/query-client";

export const JotaiStore = createStore();

// Hydrate jotai-tanstack-query's ``queryClientAtom`` with the SAME
// QueryClient instance the React tree uses (via QueryClientProvider).
// Without this, ``atomWithQuery`` falls back to its own internal
// QueryClient — and any ``queryClient.setQueryData`` /
// ``invalidateQueries`` we run from React-side code (Login pre-flight,
// manual org switch handlers, etc.) writes to a different cache than
// the atoms read from. Symptom: ``currentUserAtom`` keeps returning
// the stale (pre-login) user even after a fresh whoami has landed in
// the React queryClient. Fix is just hydrating once at module load.
JotaiStore.set(queryClientAtom, queryClient);

export { Provider as JotaiProvider };
